import _JSONBigInt from 'json-bigint';
import axios from 'axios';
import { env, Native } from '@hb/NBridge/lib/h5';
import Toast from '@/components/toast';
import CachedRequest from '@/utils/cachedRequest';
import { getSystemCode, getVersion } from '../utils/systemCode';
import { isPreRender, tryCatch } from '../utils';

const JSONBigInt = _JSONBigInt({ storeAsString: true });

// const { request: requestHandler, response: responseHandler } = AxiosInterceptor.create({
//   signature: true,
//   chaos: false,
//   systemCode: 65,
//   env: 'pro',
// });

export function handleInvalidToken() {
  Native.logout();
  window.$$user = {};
  CachedRequest.clear();
  const { fullPath, path, name } = window.$app.$route;
  const meta = tryCatch(
    () => window.$router.options.routes.filter((r) => r.name === name)[0].meta,
    null,
  );
  if (meta && meta.login) {
    const { enable, mode } = meta.login;
    if (!enable) {
      return;
    }
    if (mode === 'reload') {
      window.location.reload();
      return;
    }
    let method = '';
    if (mode === 'replace') {
      method = 'replace';
    } else if (mode === 'push') {
      method = 'push';
    } else {
      method = 'push';
    }
    if (method) {
      if (path !== '/login') {
        window.$router[method]({ path: '/login', query: { from: fullPath } });
      }
    }
  }
}

const Ax = axios.create({
  timeout: 150000,
  headers: { 'content-type': 'application/json' },
});
Ax.defaults.transformResponse = [
  (data) => {
    try {
      return JSONBigInt.parse(data);
    } catch (err) {
      return JSON.parse(data);
    }
  },
];
Ax.interceptors.request.use(async (originConfig) => {
  const config = originConfig;
  if (config.data && config.data.action) {
    config.data = {
      from: 'h5',
      systemCode: getSystemCode(),
      platform: env.platformCode,
      version: await getVersion(),
      ...config.data,
    };
  }
  // const newConfig = requestHandler(config);
  // delete newConfig.headers['x-chaos-env'];
  // delete newConfig.headers.chaos;
  // delete newConfig.headers.systemCode;
  // return newConfig;
  return config;
});

Ax.interceptors.response.use(
  async (response) => {
    // const { data, config } = responseHandler(response);
    const { data, config } = response;
    if (data.code === 103) {
      if (env.isAlipayBrowser) {
        Native.invalidToken();
      }
    }
    if (data.code === 103) {
      if (!env.isAliMP && !env.isAliMPMonitor && !env.isEasyBikeApp) {
        handleInvalidToken();
      }
      if (JSON.parse(config.data).needLogin) {
        if (env.isEasyBikeApp) {
          await Native.invalidToken();
          Native.getTokenAndKey();
        }
        if (env.isAliMP || env.isAliMPMonitor) {
          Native.getTokenAndKey();
        }
      }
    } else if (data.code !== 0 && data.success !== true && !config.noCatch) {
      if (data.code === 40210005 || data.code === 40210006 || data.code === 40210007) { // mgm错误码兼容
        window.__error = data;
        const error = new Error(data.msg || data.info || `错误码: ${data.code}`);
        error.code = data.code;
        throw error;
      } else {
        window.__error = data;
        throw new Error(data.msg || data.info);
      }
    }

    return data;
  },
  () => {
    // 这里是返回状态码不为200时候的错误处理
    if (isPreRender()) {
      return;
    }
    Toast.show('网络异常');
  },
);

export default Ax;
